import { atom } from 'jotai';

const lzSCommonsLastErrorMessageAtom = atom<string>('');

export default lzSCommonsLastErrorMessageAtom;
